import { ChangeDetectionStrategy, Component } from '@angular/core';
import { combineLatest, map } from 'rxjs';
import { IconTypes } from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import {
  BulkUploadFileStatus,
  BulkUploadService,
} from 'src/app/sessions/session/upload/bulk-upload-panel/services/bulk-upload.service';

@Component({
  selector: 'app-bulk-upload-processing',
  templateUrl: './bulk-upload-processing.component.html',
  styleUrls: ['./bulk-upload-processing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkUploadProcessingComponent {
  protected readonly IconTypes = IconTypes;

  readonly view$ = combineLatest([
    this.bulkUploadService.files$,
    this.bulkUploadService.overallProgress$,
  ]).pipe(
    map(([files, progress]) => ({
      progress,
      fileNames: files.map((file) => file.name).join(', '),
      fileCount: files.length,
      failedFileNames: files
        .filter((file) => file.status === BulkUploadFileStatus.Error)
        .map((file) => file.name),
    })),
  );

  constructor(private readonly bulkUploadService: BulkUploadService) {}
}
